// Guitar tablature: fret numbers on string lines. Exact for the voiced drop-2
// chords, whose fingerings already carry a fret per string — no inference
// needed. GP's TabNotationEngraver analogue for this app. See task #18.

/** Number of strings on the tab staff (standard 6-string). */
export const TAB_STRINGS = 6;

export interface TabStop {
  /** String index 0..5, low E → high e (matches the app's tuning arrays). */
  stringIndex: number;
  fret: number;
}
export interface TabChord {
  barIndex: number;
  beat: number;
  stops: TabStop[];
}

/** Turn fretted voicings into tab chords (drop null/unplayed strings). */
export function drawTab(
  voiced: { barIndex: number; beat: number; frets: (number | null)[] }[],
): TabChord[] {
  return voiced.map((v) => ({
    barIndex: v.barIndex,
    beat: v.beat,
    stops: v.frets
      .map((f, i): TabStop | null => (f !== null && f !== undefined ? { stringIndex: i, fret: f } : null))
      .filter((s): s is TabStop => s !== null),
  }));
}

/**
 * y (staff-spaces below the top tab line) for a string index. Tab convention:
 * the highest string (index 5) is the top line, the lowest (index 0) the
 * bottom. Lines are one staff-space apart.
 */
export function tabStringY(stringIndex: number): number {
  return TAB_STRINGS - 1 - stringIndex;
}
